import React from "react";
import { Button } from "@/components/ui/button";

/**
 * A load that failed, drawn as a terminal state.
 *
 * The counterpart to `DiagnosticNotFound`, and the other half of what
 * `LoadStatus` exists to keep apart: a screen holding no record must say
 * whether the server told it there was nothing or whether it never heard back.
 * Absorbing the rejection and drawing the empty state told a coach the system
 * was empty when it was broken; leaving the skeleton up said the request was
 * still coming when it had already failed.
 *
 * It builds no error state of its own and reads no error object (D10) — the
 * global interceptor has already toasted the reason. All this adds is a
 * truthful thing to draw and a way to ask again.
 */
export const DiagnosticLoadFailed: React.FC<{
  message: string;
  onRetry?: () => void;
}> = ({ message, onRetry }) => (
  <div className="rounded-lg border border-gray-200 bg-white p-8 text-center dark:border-slate-700 dark:bg-slate-800">
    <p className="text-sm text-gray-900 dark:text-white">{message}</p>
    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Nothing has been lost — this page just could not read it.
    </p>
    {onRetry && (
      <Button className="mt-4" onClick={onRetry} size="sm" variant="outline">
        Try again
      </Button>
    )}
  </div>
);

export default DiagnosticLoadFailed;
